function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "cheese_svg__a",
  d: "M0 0h59v59H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-2 -10)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "cheese_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cheese_svg__a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#cheese_svg__b)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 11)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFE166",
  stroke: "#844C22",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M47 29.88c-4.718 4.51-8.42 7.289-11.106 8.335-2.686 1.047-8.562 1.047-17.627 0L15 29.88l6.622-25.73L30 .15"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30.5,
  cy: 24.5,
  r: 3.5,
  fill: "#EABC20"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 13,
  r: 2,
  fill: "#F8C722"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#844C22",
  transform: "translate(0 14)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF4E2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M.344 14.184v8.238L9 25.712v-9.61z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M.302 13.848l8.605-2.151 8.258 2.15L8.907 16z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9 1v12.8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCE589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9 15.992L17 14v8.613l-8 2.982z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 3,
  r: 3,
  fill: "#E94343"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EABC20",
  stroke: "#844C22",
  d: "M30.355.21h3.289l15.623 27.64-2.512 2.02"
}))));

function SvgCheese(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 51 42"
  }, props), _ref, _ref2);
}

export default SvgCheese;